import React from "react";
import TableList from "src/components/Admin/TableList/TableList";

export default function AuditHRA() {
  return (
    <>
      <div>
        <TableList Role="Auditor-HRA" />
      </div>
    </>
  );
}
